import axiosInstance from "../api";
import { notification } from "antd";

export const sendContactMessage = async (payload) => {
  try {
    const response = await axiosInstance.post(`/list/contact_us`, payload);
    
    if (response?.data?.status_code === 200) {
        notification.success({
            message: "Success",
            description: "Email Sent Successfully",
            duration: 3,
        });
        return response?.data?.data;
    }

    notification.error({
      message: "Failed to Send Message",
      description: response?.data?.message || "An error occurred while sending your message.",
      duration: 3,
    });

    throw new Error("API returned an error response");

  } catch (error) {
    console.error("Error sending message:", error);
    notification.error({
      message: "Network Error",
      description: "Something went wrong. Please try again later.",
      duration: 3,
    });
    throw error;
  }
};
